import React from "react";
import { MdError } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ContactUs from "../../components/ContactUs";
import { CustomButton } from "../../components/CustomButton";
interface ErrorPageProps {
  message?: string;
}

const ERROR_TITLE = "Oj, något gick fel!";
const BACK_BUTTON_TEXT = "Tillbaka till startsidan";

const ErrorPage: React.FC<ErrorPageProps> = ({ message }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/");
  };

  return (
    <main className="flex-grow h-full flex items-center justify-center">
      <div className="flex flex-col justify-center items-center w-full">
        <div className="max-w-[600px] flex flex-col gap-8 w-full h-full justify-center items-center p-9 bg-primary-card rounded-lg">
          <MdError className="w-24 h-24 text-red-500" />
          <h1 className="text-white text-4xl font-nunito">{ERROR_TITLE}</h1>
          <h5 className="text-white text-xl font-nunito leading-snug text-center">
            {message || "Vi kunde inte ladda sidan. Försök igen senare."}
          </h5>
          <CustomButton
            customStyles="h-[56px] w-full sm:max-w-[330px]"
            onClick={handleBackClick}
          >
            {BACK_BUTTON_TEXT}
          </CustomButton>
          <ContactUs />
        </div>
      </div>
    </main>
  );
};

export default ErrorPage;
